import { Box, FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material';
import { ConfigEntryType } from 'config/config';
import { theme } from 'config/theme';
import _ from 'lodash';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

export const LESSON_TYPES = [
  { name: 'Went Well', color: theme.palette.custom.greenBlue },
  { name: 'Needs Improvement', color: theme.palette.custom.redWine },
  { name: 'Other', color: theme.palette.custom.black },
];

export const LESSON_TYPES_INCLUDING_BLANK = [
  ...LESSON_TYPES,
  { name: 'Blank', color: theme.palette.custom.coolGrey },
];

type RetroFormRadioFieldProps = {
  field: ConfigEntryType;
};

function RetroFormRadioField({ field }: RetroFormRadioFieldProps) {
  const {
    control,
    formState: { isSubmitting },
    setValue,
  } = useFormContext<Record<string, any>>();
  const value = useWatch({ control, name: field.entryCode, defaultValue: '' });

  return (
    <Box>
      <Controller
        control={control}
        render={({ field: radioField, fieldState }) => (
          <>
            <RadioGroup aria-labelledby="report-radios-group" name={field.entryCode} row>
              {LESSON_TYPES.map((item) => (
                <Box key={item.name}>
                  <FormControlLabel
                    {...radioField}
                    onClick={() => {
                      setValue(field.entryCode, item.name, {
                        shouldDirty: true,
                        shouldValidate: true,
                      });
                    }}
                    control={
                      <Radio
                        checked={value === item.name}
                        value={item.name}
                        size="small"
                        sx={{
                          '&.Mui-checked': {
                            color: item.color,
                          },
                        }}
                      />
                    }
                    label={item.name}
                    disabled={isSubmitting}
                  />
                </Box>
              ))}
            </RadioGroup>
            {!!fieldState.error && (
              <FormHelperText sx={{ mt: -1 }} error>
                {fieldState.error?.message}
              </FormHelperText>
            )}
          </>
        )}
        name={field.entryCode}
      />
    </Box>
  );
}

export default RetroFormRadioField;

[
  {
    entryCode: 'design',
    entryValues: ['process', 'automation', 'design'],
  },
  {
    entryCode: 'operations',
    entryValues: ['operations', 'process', 'automation'],
  },
];
